const imgsFemaleKanai = [
  {
    id: "01_face",
    src: require("../../imgs/custom/kanai/female/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/kanai/female/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/kanai/female/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/kanai/female/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/kanai/female/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/kanai/female/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/kanai/female/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/kanai/female/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/kanai/female/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/kanai/female/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/kanai/female/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/kanai/female/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/kanai/female/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/kanai/female/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/kanai/female/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/kanai/female/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/kanai/female/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/kanai/female/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/kanai/female/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "11_mole",
    src: require("../../imgs/custom/kanai/female/layer2/11_mole.png"),
    type: "layer2"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/kanai/female/layer3/01_cheeks.png"),
    type: "layer3"
  },
  {
    id: "02_cheeks",
    src: require("../../imgs/custom/kanai/female/layer3/02_cheeks.png"),
    type: "layer3"
  },
  {
    id: "03_cheeks",
    src: require("../../imgs/custom/kanai/female/layer3/03_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_glasses",
    src: require("../../imgs/custom/kanai/female/layer4/01_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/kanai/female/layer4/01_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/kanai/female/layer4/02_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/kanai/female/layer4/03_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/kanai/female/layer4/04_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/kanai/female/layer4/05_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/kanai/female/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/kanai/female/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/kanai/female/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/kanai/female/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/kanai/female/layer4/05_glasses_brown.png"),
    type: "layer4"
  },

  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/kanai/female/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/kanai/female/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/kanai/female/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/kanai/female/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/kanai/female/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/kanai/female/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_veryshort_black",
    src: require("../../imgs/custom/kanai/female/layer5/01_veryshort_black.png"),
    type: "layer5"
  },

  {
    id: "02_veryshort_black",
    src: require("../../imgs/custom/kanai/female/layer5/02_veryshort_black.png"),
    type: "layer5"
  },

  {
    id: "01_short_black",
    src: require("../../imgs/custom/kanai/female/layer5/01_short_black.png"),
    type: "layer5"
  },

  {
    id: "02_short_black",
    src: require("../../imgs/custom/kanai/female/layer5/02_short_black.png"),
    type: "layer5"
  },

  {
    id: "03_short_black",
    src: require("../../imgs/custom/kanai/female/layer5/03_short_black.png"),
    type: "layer5"
  },

  {
    id: "01_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/01_bob_black.png"),
    type: "layer5"
  },

  {
    id: "02_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/02_bob_black.png"),
    type: "layer5"
  },

  {
    id: "03_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/03_bob_black.png"),
    type: "layer5"
  },

  {
    id: "04_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/04_bob_black.png"),
    type: "layer5"
  },

  {
    id: "05_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/05_bob_black.png"),
    type: "layer5"
  },

  {
    id: "06_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/06_bob_black.png"),
    type: "layer5"
  },

  {
    id: "07_bob_black",
    src: require("../../imgs/custom/kanai/female/layer5/07_bob_black.png"),
    type: "layer5"
  },

  {
    id: "01_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/01_long_black.png"),
    type: "layer5"
  },

  {
    id: "02_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/02_long_black.png"),
    type: "layer5"
  },

  {
    id: "03_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/03_long_black.png"),
    type: "layer5"
  },

  {
    id: "04_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/04_long_black.png"),
    type: "layer5"
  },

  {
    id: "05_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/05_long_black.png"),
    type: "layer5"
  },

  {
    id: "06_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/06_long_black.png"),
    type: "layer5"
  },

  {
    id: "07_long_black",
    src: require("../../imgs/custom/kanai/female/layer5/07_long_black.png"),
    type: "layer5"
  },

  {
    id: "01_veryshort_brown",
    src: require("../../imgs/custom/kanai/female/layer5/01_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_brown",
    src: require("../../imgs/custom/kanai/female/layer5/02_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/kanai/female/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/kanai/female/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/kanai/female/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "01_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/01_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "02_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/02_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "03_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/03_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "04_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/04_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "05_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/05_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "06_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/06_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "07_bob_brown",
    src: require("../../imgs/custom/kanai/female/layer5/07_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/kanai/female/layer5/07_long_brown.png"),
    type: "layer5"
  },

  {
    id: "01_veryshort_gold",
    src: require("../../imgs/custom/kanai/female/layer5/01_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gold",
    src: require("../../imgs/custom/kanai/female/layer5/02_veryshort_gold.png"),
    type: "layer5"
  },

  {
    id: "01_short_gold",
    src: require("../../imgs/custom/kanai/female/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/kanai/female/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/kanai/female/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "01_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/01_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "02_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/02_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "03_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/03_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "04_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/04_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "05_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/05_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "06_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/06_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "07_bob_gold",
    src: require("../../imgs/custom/kanai/female/layer5/07_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/04_long_gold.png"),
    type: "layer5"
  },
  {
    id: "05_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/05_long_gold.png"),
    type: "layer5"
  },
  {
    id: "06_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/06_long_gold.png"),
    type: "layer5"
  },
  {
    id: "07_long_gold",
    src: require("../../imgs/custom/kanai/female/layer5/07_long_gold.png"),
    type: "layer5"
  },

  {
    id: "01_veryshort_grey",
    src: require("../../imgs/custom/kanai/female/layer5/01_veryshort_grey.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_grey",
    src: require("../../imgs/custom/kanai/female/layer5/02_veryshort_grey.png"),
    type: "layer5"
  },
  {
    id: "01_short_grey",
    src: require("../../imgs/custom/kanai/female/layer5/01_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_short_grey",
    src: require("../../imgs/custom/kanai/female/layer5/02_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_short_grey",
    src: require("../../imgs/custom/kanai/female/layer5/03_short_grey.png"),
    type: "layer5"
  },
  {
    id: "01_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/01_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "02_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/02_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "03_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/03_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "04_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/04_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "05_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/05_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "06_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/06_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "07_bob_grey",
    src: require("../../imgs/custom/kanai/female/layer5/07_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "01_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/01_long_grey.png"),
    type: "layer5"
  },
  {
    id: "02_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/02_long_grey.png"),
    type: "layer5"
  },
  {
    id: "03_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/03_long_grey.png"),
    type: "layer5"
  },
  {
    id: "04_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/04_long_grey.png"),
    type: "layer5"
  },
  {
    id: "05_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/05_long_grey.png"),
    type: "layer5"
  },
  {
    id: "06_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/06_long_grey.png"),
    type: "layer5"
  },
  {
    id: "07_long_grey",
    src: require("../../imgs/custom/kanai/female/layer5/07_long_grey.png"),
    type: "layer5"
  }
];
const imgsMaleKanai = [
  {
    id: "01_face",
    src: require("../../imgs/custom/kanai/male/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/kanai/male/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/kanai/male/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/kanai/male/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/kanai/male/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/kanai/male/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/kanai/male/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/kanai/male/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/kanai/male/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/kanai/male/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/kanai/male/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/kanai/male/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/kanai/male/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/kanai/male/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/kanai/male/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/kanai/male/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/kanai/male/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/kanai/male/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/kanai/male/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/kanai/male/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/kanai/male/layer3/01_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/01_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "02_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/02_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "03_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/03_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "04_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/04_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "05_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/05_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "06_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/06_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "07_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/07_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "08_mustache_black",
    src: require("../../imgs/custom/kanai/male/layer3/08_mustache_black.png"),
    type: "layer3"
  },

  {
    id: "01_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/01_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/02_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/03_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/04_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/05_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/06_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/07_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_grey",
    src: require("../../imgs/custom/kanai/male/layer3/08_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "01_glasses",
    src: require("../../imgs/custom/kanai/male/layer4/01_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/kanai/male/layer4/01_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/kanai/male/layer4/02_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/kanai/male/layer4/03_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/kanai/male/layer4/04_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/kanai/male/layer4/05_glasses_black.png"),
    type: "layer4"
  },

  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/kanai/male/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/kanai/male/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/kanai/male/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/kanai/male/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/kanai/male/layer4/05_glasses_brown.png"),
    type: "layer4"
  },

  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/kanai/male/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/kanai/male/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/kanai/male/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/kanai/male/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/kanai/male/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/kanai/male/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_veryshort_black",
    src: require("../../imgs/custom/kanai/male/layer5/01_veryshort_black.png"),
    type: "layer5"
  },

  {
    id: "02_veryshort_black",
    src: require("../../imgs/custom/kanai/male/layer5/02_veryshort_black.png"),
    type: "layer5"
  },

  {
    id: "03_veryshort_black",
    src: require("../../imgs/custom/kanai/male/layer5/03_veryshort_black.png"),
    type: "layer5"
  },

  {
    id: "04_veryshort_black",
    src: require("../../imgs/custom/kanai/male/layer5/04_veryshort_black.png"),
    type: "layer5"
  },

  {
    id: "01_short_black",
    src: require("../../imgs/custom/kanai/male/layer5/01_short_black.png"),
    type: "layer5"
  },

  {
    id: "02_short_black",
    src: require("../../imgs/custom/kanai/male/layer5/02_short_black.png"),
    type: "layer5"
  },

  {
    id: "03_short_black",
    src: require("../../imgs/custom/kanai/male/layer5/03_short_black.png"),
    type: "layer5"
  },

  {
    id: "04_short_black",
    src: require("../../imgs/custom/kanai/male/layer5/04_short_black.png"),
    type: "layer5"
  },

  {
    id: "01_medium_black",
    src: require("../../imgs/custom/kanai/male/layer5/01_medium_black.png"),
    type: "layer5"
  },

  {
    id: "02_medium_black",
    src: require("../../imgs/custom/kanai/male/layer5/02_medium_black.png"),
    type: "layer5"
  },

  {
    id: "03_medium_black",
    src: require("../../imgs/custom/kanai/male/layer5/03_medium_black.png"),
    type: "layer5"
  },

  {
    id: "04_medium_black",
    src: require("../../imgs/custom/kanai/male/layer5/04_medium_black.png"),
    type: "layer5"
  },

  {
    id: "05_medium_black",
    src: require("../../imgs/custom/kanai/male/layer5/05_medium_black.png"),
    type: "layer5"
  },

  {
    id: "01_long_black",
    src: require("../../imgs/custom/kanai/male/layer5/01_long_black.png"),
    type: "layer5"
  },

  {
    id: "02_long_black",
    src: require("../../imgs/custom/kanai/male/layer5/02_long_black.png"),
    type: "layer5"
  },

  {
    id: "03_long_black",
    src: require("../../imgs/custom/kanai/male/layer5/03_long_black.png"),
    type: "layer5"
  },

  {
    id: "04_long_black",
    src: require("../../imgs/custom/kanai/male/layer5/04_long_black.png"),
    type: "layer5"
  },

  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/kanai/male/layer4/05_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_veryshort_brown",
    src: require("../../imgs/custom/kanai/male/layer5/02_veryshort_brown.png"),
    type: "layer5"
  },

  {
    id: "01_veryshort_brown",
    src: require("../../imgs/custom/kanai/male/layer5/01_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_brown",
    src: require("../../imgs/custom/kanai/male/layer5/03_veryshort_brown.png"),
    type: "layer5"
  },

  {
    id: "04_veryshort_brown",
    src: require("../../imgs/custom/kanai/male/layer5/04_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/kanai/male/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/kanai/male/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/kanai/male/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/kanai/male/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/kanai/male/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/kanai/male/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/kanai/male/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/kanai/male/layer5/04_medium_brown.png"),
    type: "layer5"
  },

  {
    id: "05_medium_brown",
    src: require("../../imgs/custom/kanai/male/layer5/05_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/kanai/male/layer5/01_long_brown.png"),
    type: "layer5"
  },

  {
    id: "02_long_brown",
    src: require("../../imgs/custom/kanai/male/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/kanai/male/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/kanai/male/layer5/04_long_brown.png"),
    type: "layer5"
  },

  {
    id: "01_veryshort_gold",
    src: require("../../imgs/custom/kanai/male/layer5/01_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gold",
    src: require("../../imgs/custom/kanai/male/layer5/02_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gold",
    src: require("../../imgs/custom/kanai/male/layer5/03_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gold",
    src: require("../../imgs/custom/kanai/male/layer5/04_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/kanai/male/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/kanai/male/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/kanai/male/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/kanai/male/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/kanai/male/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/kanai/male/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/kanai/male/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/kanai/male/layer5/04_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gold",
    src: require("../../imgs/custom/kanai/male/layer5/05_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/kanai/male/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/kanai/male/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/kanai/male/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/kanai/male/layer5/04_long_gold.png"),
    type: "layer5"
  },

  {
    id: "01_veryshort_grey",
    src: require("../../imgs/custom/kanai/male/layer5/01_veryshort_grey.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_grey",
    src: require("../../imgs/custom/kanai/male/layer5/02_veryshort_grey.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_grey",
    src: require("../../imgs/custom/kanai/male/layer5/03_veryshort_grey.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_grey",
    src: require("../../imgs/custom/kanai/male/layer5/04_veryshort_grey.png"),
    type: "layer5"
  },
  {
    id: "01_short_grey",
    src: require("../../imgs/custom/kanai/male/layer5/01_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_short_grey",
    src: require("../../imgs/custom/kanai/male/layer5/02_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_short_grey",
    src: require("../../imgs/custom/kanai/male/layer5/03_short_grey.png"),
    type: "layer5"
  },
  {
    id: "04_short_grey",
    src: require("../../imgs/custom/kanai/male/layer5/04_short_grey.png"),
    type: "layer5"
  },
  {
    id: "01_medium_grey",
    src: require("../../imgs/custom/kanai/male/layer5/01_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "02_medium_grey",
    src: require("../../imgs/custom/kanai/male/layer5/02_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "03_medium_grey",
    src: require("../../imgs/custom/kanai/male/layer5/03_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "04_medium_grey",
    src: require("../../imgs/custom/kanai/male/layer5/04_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "05_medium_grey",
    src: require("../../imgs/custom/kanai/male/layer5/05_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "01_long_grey",
    src: require("../../imgs/custom/kanai/male/layer5/01_long_grey.png"),
    type: "layer5"
  },
  {
    id: "02_long_grey",
    src: require("../../imgs/custom/kanai/male/layer5/02_long_grey.png"),
    type: "layer5"
  },
  {
    id: "03_long_grey",
    src: require("../../imgs/custom/kanai/male/layer5/03_long_grey.png"),
    type: "layer5"
  },
  {
    id: "04_long_grey",
    src: require("../../imgs/custom/kanai/male/layer5/04_long_grey.png"),
    type: "layer5"
  }
];

const imgsFemaleNakagawa = [
  {
    id: "03_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "01_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/nakagawa/female/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/nakagawa/female/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "00_cheeks",
    src: require("../../imgs/custom/nakagawa/female/layer3/00_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/nakagawa/female/layer3/01_cheeks.png"),
    type: "layer3"
  },
  {
    id: "02_cheeks",
    src: require("../../imgs/custom/nakagawa/female/layer3/02_cheeks.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/nakagawa/female/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/nakagawa/female/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/nakagawa/female/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/nakagawa/female/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/nakagawa/female/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/nakagawa/female/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_blue",
    src: require("../../imgs/custom/nakagawa/female/layer4/01_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_blue",
    src: require("../../imgs/custom/nakagawa/female/layer4/02_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_blue",
    src: require("../../imgs/custom/nakagawa/female/layer4/03_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_blue",
    src: require("../../imgs/custom/nakagawa/female/layer4/04_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_blue",
    src: require("../../imgs/custom/nakagawa/female/layer4/05_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/nakagawa/female/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/nakagawa/female/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/nakagawa/female/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/nakagawa/female/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/nakagawa/female/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/nakagawa/female/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/01_hair_black.png"),
    type: "layer5"
  },
  {
    id: "02_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/02_hair_black.png"),
    type: "layer5"
  },
  {
    id: "03_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/03_hair_black.png"),
    type: "layer5"
  },
  {
    id: "04_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/04_hair_black.png"),
    type: "layer5"
  },
  {
    id: "05_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/05_hair_black.png"),
    type: "layer5"
  },

  //bob
  {
    id: "12_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/12_hair_black.png"),
    type: "layer5"
  },
  {
    id: "13_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/13_hair_black.png"),
    type: "layer5"
  },
  {
    id: "14_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/14_hair_black.png"),
    type: "layer5"
  },
  {
    id: "15_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/15_hair_black.png"),
    type: "layer5"
  },
  {
    id: "16_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/16_hair_black.png"),
    type: "layer5"
  },
  {
    id: "17_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/17_hair_black.png"),
    type: "layer5"
  },
  {
    id: "18_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/18_hair_black.png"),
    type: "layer5"
  },

  //long
  {
    id: "06_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/06_hair_black.png"),
    type: "layer5"
  },
  {
    id: "07_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/07_hair_black.png"),
    type: "layer5"
  },
  {
    id: "08_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/08_hair_black.png"),
    type: "layer5"
  },
  {
    id: "09_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/09_hair_black.png"),
    type: "layer5"
  },
  {
    id: "10_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/10_hair_black.png"),
    type: "layer5"
  },
  {
    id: "11_hair_black",
    src: require("../../imgs/custom/nakagawa/female/layer5/11_hair_black.png"),
    type: "layer5"
  },

  {
    id: "01_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/01_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "02_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/02_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "03_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/03_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "04_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/04_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "05_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/05_hair_brown.png"),
    type: "layer5"
  },
  //bob
  {
    id: "12_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/12_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "13_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/13_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "14_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/14_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "15_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/15_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "16_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/16_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "17_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/17_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "18_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/18_hair_brown.png"),
    type: "layer5"
  },
  //long
  {
    id: "06_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/06_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "07_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/07_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "08_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/08_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "09_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/09_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "10_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/10_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "11_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/11_hair_brown.png"),
    type: "layer5"
  },
  //bob
  {
    id: "12_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/12_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "13_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/13_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "14_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/14_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "15_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/15_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "16_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/16_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "17_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/17_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "18_hair_brown",
    src: require("../../imgs/custom/nakagawa/female/layer5/18_hair_brown.png"),
    type: "layer5"
  },

  {
    id: "01_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/01_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "02_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/02_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "03_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/03_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "04_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/04_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "05_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/05_hair_gold.png"),
    type: "layer5"
  },
  //bob
  {
    id: "12_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/12_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "13_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/13_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "14_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/14_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "15_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/15_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "16_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/16_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "17_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/17_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "18_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/18_hair_gold.png"),
    type: "layer5"
  },
  //long
  {
    id: "06_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/06_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "07_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/07_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "08_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/08_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "09_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/09_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "10_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/10_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "11_hair_gold",
    src: require("../../imgs/custom/nakagawa/female/layer5/11_hair_gold.png"),
    type: "layer5"
  },

  {
    id: "01_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/01_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "02_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/02_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "03_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/03_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "04_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/04_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "05_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/05_hair_silver.png"),
    type: "layer5"
  },

  //bob

  {
    id: "12_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/12_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "13_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/13_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "14_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/14_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "15_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/15_hair_silver.png"),
    type: "layer5"
  },
  {
    id: "16_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/16_hair_silver.png"),
    type: "layer5"
  },
  {
    id: "17_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/17_hair_silver.png"),
    type: "layer5"
  },
  {
    id: "18_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/18_hair_silver.png"),
    type: "layer5"
  },

  //long
  {
    id: "06_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/06_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "07_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/07_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "08_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/08_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "09_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/09_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "10_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/10_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "11_hair_silver",
    src: require("../../imgs/custom/nakagawa/female/layer5/11_hair_silver.png"),
    type: "layer5"
  }
];
const imgsMaleNakagawa = [
  {
    id: "03_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "01_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/nakagawa/male/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/nakagawa/male/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/nakagawa/male/layer3/01_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/01_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/02_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/03_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/04_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/05_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/06_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/07_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/08_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "09_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/09_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "10_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/10_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "11_mustache_brown",
    src: require("../../imgs/custom/nakagawa/male/layer3/11_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/01_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/02_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/03_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/04_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/05_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/06_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/07_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/08_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "09_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/09_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "10_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/10_mustache_silver.png"),
    type: "layer3"
  },

  {
    id: "11_mustache_silver",
    src: require("../../imgs/custom/nakagawa/male/layer3/11_mustache_silver.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/nakagawa/male/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/nakagawa/male/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/nakagawa/male/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/nakagawa/male/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/nakagawa/male/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/nakagawa/male/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_blue",
    src: require("../../imgs/custom/nakagawa/male/layer4/01_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_blue",
    src: require("../../imgs/custom/nakagawa/male/layer4/02_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_blue",
    src: require("../../imgs/custom/nakagawa/male/layer4/03_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_blue",
    src: require("../../imgs/custom/nakagawa/male/layer4/04_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_blue",
    src: require("../../imgs/custom/nakagawa/male/layer4/05_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/nakagawa/male/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/nakagawa/male/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/nakagawa/male/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/nakagawa/male/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/nakagawa/male/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/nakagawa/male/layer5/00_hair.png"),
    type: "layer5"
  },
  //very short
  {
    id: "01_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/01_hair_black.png"),
    type: "layer5"
  },
  {
    id: "02_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/02_hair_black.png"),
    type: "layer5"
  },
  {
    id: "03_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/03_hair_black.png"),
    type: "layer5"
  },
  {
    id: "04_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/04_hair_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "06_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/06_hair_black.png"),
    type: "layer5"
  },
  {
    id: "07_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/07_hair_black.png"),
    type: "layer5"
  },
  {
    id: "05_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/05_hair_black.png"),
    type: "layer5"
  },
  {
    id: "08_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/08_hair_black.png"),
    type: "layer5"
  },
  {
    id: "09_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/09_hair_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "14_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/14_hair_black.png"),
    type: "layer5"
  },
  {
    id: "15_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/15_hair_black.png"),
    type: "layer5"
  },
  {
    id: "16_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/16_hair_black.png"),
    type: "layer5"
  },
  {
    id: "17_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/17_hair_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "10_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/10_hair_black.png"),
    type: "layer5"
  },
  {
    id: "11_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/11_hair_black.png"),
    type: "layer5"
  },
  {
    id: "12_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/12_hair_black.png"),
    type: "layer5"
  },
  {
    id: "13_hair_black",
    src: require("../../imgs/custom/nakagawa/male/layer5/13_hair_black.png"),
    type: "layer5"
  },
  //Very small
  {
    id: "01_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/01_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "02_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/02_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "03_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/03_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "04_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/04_hair_brown.png"),
    type: "layer5"
  },
  //short
  {
    id: "05_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/05_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "06_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/06_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "07_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/07_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "08_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/08_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "09_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/09_hair_brown.png"),
    type: "layer5"
  },
  //Medium
  {
    id: "14_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/14_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "15_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/15_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "16_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/16_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "17_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/17_hair_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "10_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/10_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "11_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/11_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "12_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/12_hair_brown.png"),
    type: "layer5"
  },
  {
    id: "13_hair_brown",
    src: require("../../imgs/custom/nakagawa/male/layer5/13_hair_brown.png"),
    type: "layer5"
  },
  //Very short
  {
    id: "01_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/01_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "02_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/02_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "03_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/03_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "04_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/04_hair_gold.png"),
    type: "layer5"
  },
  //Short
  {
    id: "05_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/05_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "06_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/06_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "07_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/07_hair_gold.png"),
    type: "layer5"
  },

  {
    id: "08_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/08_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "09_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/09_hair_gold.png"),
    type: "layer5"
  },
  //Medium
  {
    id: "14_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/14_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "15_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/15_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "16_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/16_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "17_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/17_hair_gold.png"),
    type: "layer5"
  },
  //Long
  {
    id: "10_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/10_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "11_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/11_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "12_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/12_hair_gold.png"),
    type: "layer5"
  },
  {
    id: "13_hair_gold",
    src: require("../../imgs/custom/nakagawa/male/layer5/13_hair_gold.png"),
    type: "layer5"
  },
  //Very small
  {
    id: "01_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/01_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "02_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/02_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "03_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/03_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "04_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/04_hair_silver.png"),
    type: "layer5"
  },
  //Short
  {
    id: "05_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/05_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "06_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/06_hair_silver.png"),
    type: "layer5"
  },
  {
    id: "07_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/07_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "08_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/08_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "09_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/09_hair_silver.png"),
    type: "layer5"
  },
  //Medium

  {
    id: "14_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/14_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "15_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/15_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "16_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/16_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "17_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/17_hair_silver.png"),
    type: "layer5"
  },
  //Long
  {
    id: "10_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/10_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "11_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/11_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "12_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/12_hair_silver.png"),
    type: "layer5"
  },

  {
    id: "13_hair_silver",
    src: require("../../imgs/custom/nakagawa/male/layer5/13_hair_silver.png"),
    type: "layer5"
  }
];
const imgsBoyNakagawa = [
  {
    id: "01_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/nakagawa/boy/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/nakagawa/boy/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/nakagawa/boy/layer3/00_cheek.png"),
    type: "layer3"
  },
  {
    id: "01_cheek",
    src: require("../../imgs/custom/nakagawa/boy/layer3/01_cheek.png"),
    type: "layer3"
  },
  {
    id: "02_sobakasu",
    src: require("../../imgs/custom/nakagawa/boy/layer3/02_sobakasu.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/nakagawa/boy/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/nakagawa/boy/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/nakagawa/boy/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/nakagawa/boy/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/nakagawa/boy/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_blue",
    src: require("../../imgs/custom/nakagawa/boy/layer4/01_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_blue",
    src: require("../../imgs/custom/nakagawa/boy/layer4/02_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_blue",
    src: require("../../imgs/custom/nakagawa/boy/layer4/03_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_blue",
    src: require("../../imgs/custom/nakagawa/boy/layer4/04_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/nakagawa/boy/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/nakagawa/boy/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/nakagawa/boy/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/nakagawa/boy/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/nakagawa/boy/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_baby",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_baby.png"),
    type: "layer5"
  },
  // black
  // very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_very_short_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/05_short_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_mid_black.png"),
    type: "layer5"
  },
  {
    id: "02_mid_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_mid_black.png"),
    type: "layer5"
  },
  {
    id: "03_mid_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_mid_black.png"),
    type: "layer5"
  },
  {
    id: "04_mid_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_mid_black.png"),
    type: "layer5"
  },
  {
    id: "05_mid_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/05_mid_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_long_black.png"),
    type: "layer5"
  },
  // brown
  // very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_very_short_brown.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/05_short_brown.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "02_mid_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "03_mid_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "04_mid_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "05_mid_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/05_mid_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_long_brown.png"),
    type: "layer5"
  },
  // yellow
  // very short
  {
    id: "01_very_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_very_short_yellow.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_short_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/05_short_yellow.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_mid_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_mid_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/03_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_mid_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/04_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_mid_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/05_mid_yellow.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/01_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_long_yellow",
    src: require("../../imgs/custom/nakagawa/boy/layer5/02_long_yellow.png"),
    type: "layer5"
  },
];
const imgsGirlNakagawa = [
  {
    id: "01_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/nakagawa/girl/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/nakagawa/girl/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/nakagawa/girl/layer3/00_cheek.png"),
    type: "layer3"
  },
  {
    id: "01_cheek",
    src: require("../../imgs/custom/nakagawa/girl/layer3/01_cheek.png"),
    type: "layer3"
  },
  {
    id: "02_sobakasu",
    src: require("../../imgs/custom/nakagawa/girl/layer3/02_sobakasu.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/nakagawa/girl/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/nakagawa/girl/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/nakagawa/girl/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/nakagawa/girl/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/nakagawa/girl/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_blue",
    src: require("../../imgs/custom/nakagawa/girl/layer4/01_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_blue",
    src: require("../../imgs/custom/nakagawa/girl/layer4/02_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_blue",
    src: require("../../imgs/custom/nakagawa/girl/layer4/03_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_blue",
    src: require("../../imgs/custom/nakagawa/girl/layer4/04_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/nakagawa/girl/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/nakagawa/girl/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/nakagawa/girl/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/nakagawa/girl/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/nakagawa/girl/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_baby",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_baby.png"),
    type: "layer5"
  },
  // black
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/04_short_black.png"),
    type: "layer5"
  },
  // bob
  {
    id: "01_bob_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_bob_black.png"),
    type: "layer5"
  },
  {
    id: "02_bob_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_bob_black.png"),
    type: "layer5"
  },
  {
    id: "03_bob_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_bob_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/06_long_black.png"),
    type: "layer5"
  },
  {
    id: "07_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/07_long_black.png"),
    type: "layer5"
  },
  {
    id: "08_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/08_long_black.png"),
    type: "layer5"
  },
  {
    id: "09_long_black",
    src: require("../../imgs/custom/nakagawa/girl/layer5/09_long_black.png"),
    type: "layer5"
  },
  // brown
  //short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/04_short_brown.png"),
    type: "layer5"
  },
  // bob
  {
    id: "01_bob_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "02_bob_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "03_bob_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_bob_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/07_long_brown.png"),
    type: "layer5"
  },
  {
    id: "08_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/08_long_brown.png"),
    type: "layer5"
  },
  {
    id: "09_long_brown",
    src: require("../../imgs/custom/nakagawa/girl/layer5/09_long_brown.png"),
    type: "layer5"
  },
  // yellow
  //short
  {
    id: "01_short_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_short_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_short_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_short_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/04_short_yellow.png"),
    type: "layer5"
  },
  // bob
  {
    id: "01_bob_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_bob_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_bob_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_bob_yellow.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/01_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/02_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/03_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/04_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/05_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "06_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/06_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "07_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/07_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "08_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/08_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "09_long_yellow",
    src: require("../../imgs/custom/nakagawa/girl/layer5/09_long_yellow.png"),
    type: "layer5"
  },
];
const imgsPapaNakagawa = [
  {
    id: "01_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/nakagawa/papa/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/nakagawa/papa/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/nakagawa/papa/layer3/00_cheek.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/01_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/02_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/03_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/04_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/05_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/06_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/07_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/08_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "09_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/09_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "10_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/10_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "11_mustache_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer3/11_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/01_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/02_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/03_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/04_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/05_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/06_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/07_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/08_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "09_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/09_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "10_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/10_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "11_mustache_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer3/11_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/nakagawa/papa/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/nakagawa/papa/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/nakagawa/papa/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/nakagawa/papa/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/nakagawa/papa/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/nakagawa/papa/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_blue",
    src: require("../../imgs/custom/nakagawa/papa/layer4/01_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_blue",
    src: require("../../imgs/custom/nakagawa/papa/layer4/02_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_blue",
    src: require("../../imgs/custom/nakagawa/papa/layer4/03_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_blue",
    src: require("../../imgs/custom/nakagawa/papa/layer4/04_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_blue",
    src: require("../../imgs/custom/nakagawa/papa/layer4/05_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/nakagawa/papa/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/nakagawa/papa/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/nakagawa/papa/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/nakagawa/papa/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/nakagawa/papa/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/nakagawa/papa/layer5/00_hair.png"),
    type: "layer5"
  },
  // black
  // very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_very_short_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/05_short_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_medium_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_medium_black.png"),
    type: "layer5"
  },
  {
    id: "02_medium_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_medium_black.png"),
    type: "layer5"
  },
  {
    id: "03_medium_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_medium_black.png"),
    type: "layer5"
  },
  {
    id: "04_medium_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_medium_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_long_black.png"),
    type: "layer5"
  },
  // brown
  // very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_very_short_brown.png"),
    type: "layer5"
  },
//short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/05_short_brown.png"),
    type: "layer5"
  },
// Medium
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_medium_brown.png"),
    type: "layer5"
  },
//Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_long_brown.png"),
    type: "layer5"
  },
  // gold
  // very short
  {
    id: "01_very_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_very_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_very_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_very_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_very_short_gold.png"),
    type: "layer5"
  },
//short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/05_short_gold.png"),
    type: "layer5"
  },
// Medium
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_medium_gold.png"),
    type: "layer5"
  },
//Long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_long_gold.png"),
    type: "layer5"
  },
  // grey
  // very short
  {
    id: "01_very_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_very_short_grey.png"),
    type: "layer5"
  },
//short
  {
    id: "01_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_short_grey.png"),
    type: "layer5"
  },
  {
    id: "04_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_short_grey.png"),
    type: "layer5"
  },
  {
    id: "05_short_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/05_short_grey.png"),
    type: "layer5"
  },
// Medium
  {
    id: "01_medium_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "02_medium_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "03_medium_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "04_medium_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_medium_grey.png"),
    type: "layer5"
  },
//Long
  {
    id: "01_long_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/01_long_grey.png"),
    type: "layer5"
  },
  {
    id: "02_long_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/02_long_grey.png"),
    type: "layer5"
  },
  {
    id: "03_long_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/03_long_grey.png"),
    type: "layer5"
  },
  {
    id: "04_long_grey",
    src: require("../../imgs/custom/nakagawa/papa/layer5/04_long_grey.png"),
    type: "layer5"
  },
];
const imgsMamaNakagawa = [
  {
    id: "01_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/nakagawa/mama/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/nakagawa/mama/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/nakagawa/mama/layer3/00_cheek.png"),
    type: "layer3"
  },
  {
    id: "01_cheek",
    src: require("../../imgs/custom/nakagawa/mama/layer3/01_cheek.png"),
    type: "layer3"
  },
  {
    id: "02_sobakasu",
    src: require("../../imgs/custom/nakagawa/mama/layer3/02_sobakasu.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/nakagawa/mama/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/nakagawa/mama/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/nakagawa/mama/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/nakagawa/mama/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/nakagawa/mama/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/nakagawa/mama/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_blue",
    src: require("../../imgs/custom/nakagawa/mama/layer4/01_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_blue",
    src: require("../../imgs/custom/nakagawa/mama/layer4/02_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_blue",
    src: require("../../imgs/custom/nakagawa/mama/layer4/03_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_blue",
    src: require("../../imgs/custom/nakagawa/mama/layer4/04_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_blue",
    src: require("../../imgs/custom/nakagawa/mama/layer4/05_glasses_blue.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/nakagawa/mama/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/nakagawa/mama/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/nakagawa/mama/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/nakagawa/mama/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/nakagawa/mama/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/nakagawa/mama/layer5/00_hair.png"),
    type: "layer5"
  },
  // black
  // very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_short_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_medium_black.png"),
    type: "layer5"
  },
  {
    id: "02_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_medium_black.png"),
    type: "layer5"
  },
  {
    id: "03_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_medium_black.png"),
    type: "layer5"
  },
  {
    id: "04_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_medium_black.png"),
    type: "layer5"
  },
  {
    id: "05_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_medium_black.png"),
    type: "layer5"
  },
  {
    id: "06_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_medium_black.png"),
    type: "layer5"
  },
  {
    id: "07_medium_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/07_medium_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_long_black.png"),
    type: "layer5"
  },
  // brown
  // very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_short_brown.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "05_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "06_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "07_medium_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/07_medium_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_long_brown.png"),
    type: "layer5"
  },
  // gold
  // very short
  {
    id: "01_very_short_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_very_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_very_short_gold.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_short_gold.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "07_medium_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/07_medium_gold.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_long_gold.png"),
    type: "layer5"
  },
  {
    id: "05_long_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_long_gold.png"),
    type: "layer5"
  },
  {
    id: "06_long_gold",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_long_gold.png"),
    type: "layer5"
  },
  // grey
  // very short
  {
    id: "01_very_short_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_very_short_grey.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_short_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_short_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_short_grey.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "02_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "03_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "04_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "05_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "06_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_medium_grey.png"),
    type: "layer5"
  },
  {
    id: "07_medium_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/07_medium_grey.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/01_long_grey.png"),
    type: "layer5"
  },
  {
    id: "02_long_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/02_long_grey.png"),
    type: "layer5"
  },
  {
    id: "03_long_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/03_long_grey.png"),
    type: "layer5"
  },
  {
    id: "04_long_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/04_long_grey.png"),
    type: "layer5"
  },
  {
    id: "05_long_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/05_long_grey.png"),
    type: "layer5"
  },
  {
    id: "06_long_grey",
    src: require("../../imgs/custom/nakagawa/mama/layer5/06_long_grey.png"),
    type: "layer5"
  },
];


const imgsBoyMomoro = [
  {
    id: "01_face",
    src: require("../../imgs/custom/momoro/boy/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/momoro/boy/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/momoro/boy/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/momoro/boy/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/momoro/boy/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/momoro/boy/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/momoro/boy/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/momoro/boy/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/momoro/boy/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/00_mole.png"),
    type: "layer3"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/01_mole.png"),
    type: "layer3"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/02_mole.png"),
    type: "layer3"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/03_mole.png"),
    type: "layer3"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/04_mole.png"),
    type: "layer3"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/05_mole.png"),
    type: "layer3"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/06_mole.png"),
    type: "layer3"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/07_mole.png"),
    type: "layer3"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/08_mole.png"),
    type: "layer3"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/09_mole.png"),
    type: "layer3"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/momoro/boy/layer3/10_mole.png"),
    type: "layer3"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/momoro/boy/layer2/00_cheek.png"),
    type: "layer2"
  },
  {
    id: "01_cheek",
    src: require("../../imgs/custom/momoro/boy/layer2/01_cheek.png"),
    type: "layer2"
  },
  {
    id: "02_freckles",
    src: require("../../imgs/custom/momoro/boy/layer2/02_freckles.png"),
    type: "layer2"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/momoro/boy/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/momoro/boy/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/momoro/boy/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/momoro/boy/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/momoro/boy/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/momoro/boy/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/momoro/boy/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/momoro/boy/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/momoro/boy/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/momoro/boy/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/momoro/boy/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/momoro/boy/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/momoro/boy/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/momoro/boy/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_baby",
    src: require("../../imgs/custom/momoro/boy/layer5/01_baby.png"),
    type: "layer5"
  },
  {
    id: "02_baby",
    src: require("../../imgs/custom/momoro/boy/layer5/02_baby.png"),
    type: "layer5"
  },
  // black
  // very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/03_very_short_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/momoro/boy/layer5/05_short_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_black",
    src: require("../../imgs/custom/momoro/boy/layer5/01_mid_black.png"),
    type: "layer5"
  },
  {
    id: "02_mid_black",
    src: require("../../imgs/custom/momoro/boy/layer5/02_mid_black.png"),
    type: "layer5"
  },
  {
    id: "03_mid_black",
    src: require("../../imgs/custom/momoro/boy/layer5/03_mid_black.png"),
    type: "layer5"
  },
  {
    id: "04_mid_black",
    src: require("../../imgs/custom/momoro/boy/layer5/04_mid_black.png"),
    type: "layer5"
  },
  {
    id: "05_mid_black",
    src: require("../../imgs/custom/momoro/boy/layer5/05_mid_black.png"),
    type: "layer5"
  },
  {
    id: "06_mid_black",
    src: require("../../imgs/custom/momoro/boy/layer5/06_mid_black.png"),
    type: "layer5"
  },
  // brown
  // very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/03_very_short_brown.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/05_short_brown.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/01_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "02_mid_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/02_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "03_mid_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/03_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "04_mid_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/04_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "05_mid_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/05_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "06_mid_brown",
    src: require("../../imgs/custom/momoro/boy/layer5/06_mid_brown.png"),
    type: "layer5"
  },
  // yellow
  // very short
  {
    id: "01_very_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/01_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/02_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/03_very_short_yellow.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/01_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/02_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/03_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/04_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_short_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/05_short_yellow.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/01_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_mid_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/02_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_mid_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/03_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_mid_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/04_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_mid_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/05_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "06_mid_yellow",
    src: require("../../imgs/custom/momoro/boy/layer5/06_mid_yellow.png"),
    type: "layer5"
  },
];
const imgsGirlMomoro = [
  {
    id: "01_face",
    src: require("../../imgs/custom/momoro/girl/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/momoro/girl/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/momoro/girl/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/momoro/girl/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/momoro/girl/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/momoro/girl/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/momoro/girl/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/momoro/girl/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/momoro/girl/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/00_mole.png"),
    type: "layer3"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/01_mole.png"),
    type: "layer3"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/02_mole.png"),
    type: "layer3"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/03_mole.png"),
    type: "layer3"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/04_mole.png"),
    type: "layer3"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/05_mole.png"),
    type: "layer3"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/06_mole.png"),
    type: "layer3"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/07_mole.png"),
    type: "layer3"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/08_mole.png"),
    type: "layer3"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/09_mole.png"),
    type: "layer3"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/momoro/girl/layer3/10_mole.png"),
    type: "layer3"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/momoro/girl/layer2/00_cheek.png"),
    type: "layer2"
  },
  {
    id: "01_cheek",
    src: require("../../imgs/custom/momoro/girl/layer2/01_cheek.png"),
    type: "layer2"
  },
  {
    id: "01_freckles",
    src: require("../../imgs/custom/momoro/girl/layer2/01_freckles.png"),
    type: "layer2"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/momoro/girl/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/momoro/girl/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/momoro/girl/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/momoro/girl/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/momoro/girl/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/momoro/girl/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/momoro/girl/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/momoro/girl/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/momoro/girl/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/momoro/girl/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/momoro/girl/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/momoro/girl/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/momoro/girl/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/momoro/girl/layer5/00_hair.png"),
    type: "layer5"
  },
  {
    id: "01_baby",
    src: require("../../imgs/custom/momoro/girl/layer5/01_baby.png"),
    type: "layer5"
  },
  {
    id: "02_baby",
    src: require("../../imgs/custom/momoro/girl/layer5/02_baby.png"),
    type: "layer5"
  },
  // black
  //very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/momoro/girl/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/momoro/girl/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_black",
    src: require("../../imgs/custom/momoro/girl/layer5/03_very_short_black.png"),
    type: "layer5"
  },
  // bob
  {
    id: "01_bob_black",
    src: require("../../imgs/custom/momoro/girl/layer5/01_bob_black.png"),
    type: "layer5"
  },
  {
    id: "02_bob_black",
    src: require("../../imgs/custom/momoro/girl/layer5/02_bob_black.png"),
    type: "layer5"
  },
  {
    id: "03_bob_black",
    src: require("../../imgs/custom/momoro/girl/layer5/03_bob_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/06_long_black.png"),
    type: "layer5"
  },
  {
    id: "07_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/07_long_black.png"),
    type: "layer5"
  },
  {
    id: "08_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/08_long_black.png"),
    type: "layer5"
  },
  {
    id: "09_long_black",
    src: require("../../imgs/custom/momoro/girl/layer5/09_long_black.png"),
    type: "layer5"
  },
  // brown
  //very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/03_very_short_brown.png"),
    type: "layer5"
  },
  // bob
  {
    id: "01_bob_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/01_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "02_bob_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/02_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "03_bob_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/03_bob_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/07_long_brown.png"),
    type: "layer5"
  },
  {
    id: "08_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/08_long_brown.png"),
    type: "layer5"
  },
  {
    id: "09_long_brown",
    src: require("../../imgs/custom/momoro/girl/layer5/09_long_brown.png"),
    type: "layer5"
  },
  // yellow
  //very short
  {
    id: "01_very_short_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/01_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/02_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/03_very_short_yellow.png"),
    type: "layer5"
  },
  // bob
  {
    id: "01_bob_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/01_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_bob_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/02_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_bob_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/03_bob_yellow.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/01_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/02_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/03_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/04_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/05_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "06_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/06_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "07_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/07_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "08_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/08_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "09_long_yellow",
    src: require("../../imgs/custom/momoro/girl/layer5/09_long_yellow.png"),
    type: "layer5"
  },
];
const imgsPapaMomoro = [
  {
    id: "01_face",
    src: require("../../imgs/custom/momoro/papa/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/momoro/papa/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/momoro/papa/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/momoro/papa/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/momoro/papa/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/momoro/papa/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/momoro/papa/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/momoro/papa/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/momoro/papa/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/momoro/papa/layer2/10_mole.png"),
    type: "layer2"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/momoro/papa/layer3/00_cheek.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/01_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/02_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/03_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/04_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/05_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/06_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/07_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/08_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "09_mustache_brown",
    src: require("../../imgs/custom/momoro/papa/layer3/09_mustache_brown.png"),
    type: "layer3"
  },
  {
    id: "01_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/01_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "02_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/02_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "03_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/03_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "04_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/04_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "05_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/05_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "06_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/06_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "07_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/07_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "08_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/08_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "09_mustache_grey",
    src: require("../../imgs/custom/momoro/papa/layer3/09_mustache_grey.png"),
    type: "layer3"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/momoro/papa/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/momoro/papa/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/momoro/papa/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/momoro/papa/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/momoro/papa/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/momoro/papa/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/momoro/papa/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/momoro/papa/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/momoro/papa/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/momoro/papa/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/momoro/papa/layer4/05_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/momoro/papa/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/momoro/papa/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/momoro/papa/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/momoro/papa/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/momoro/papa/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/momoro/papa/layer5/00_hair.png"),
    type: "layer5"
  },
  // black
  // very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/03_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/04_very_short_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/momoro/papa/layer5/05_short_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_black",
    src: require("../../imgs/custom/momoro/papa/layer5/01_mid_black.png"),
    type: "layer5"
  },
  {
    id: "02_mid_black",
    src: require("../../imgs/custom/momoro/papa/layer5/02_mid_black.png"),
    type: "layer5"
  },
  {
    id: "03_mid_black",
    src: require("../../imgs/custom/momoro/papa/layer5/03_mid_black.png"),
    type: "layer5"
  },
  {
    id: "04_mid_black",
    src: require("../../imgs/custom/momoro/papa/layer5/04_mid_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/momoro/papa/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/momoro/papa/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/momoro/papa/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/momoro/papa/layer5/04_long_black.png"),
    type: "layer5"
  },
  // brown
  // very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/03_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/04_very_short_brown.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/05_short_brown.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/01_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "02_mid_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/02_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "03_mid_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/03_mid_brown.png"),
    type: "layer5"
  },
  {
    id: "04_mid_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/04_mid_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/momoro/papa/layer5/04_long_brown.png"),
    type: "layer5"
  },
  // gold
  // very short
  {
    id: "01_very_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/01_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/02_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/03_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/04_very_short_yellow.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/01_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/02_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/03_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/04_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_short_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/05_short_yellow.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/01_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_mid_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/02_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_mid_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/03_mid_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_mid_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/04_mid_yellow.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/01_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_long_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/02_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_long_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/03_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_long_yellow",
    src: require("../../imgs/custom/momoro/papa/layer5/04_long_yellow.png"),
    type: "layer5"
  },
  // grey
  // very short
  {
    id: "01_very_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/01_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/02_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_very_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/03_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "04_very_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/04_very_short_grey.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/01_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/02_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/03_short_grey.png"),
    type: "layer5"
  },
  {
    id: "04_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/04_short_grey.png"),
    type: "layer5"
  },
  {
    id: "05_short_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/05_short_grey.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_mid_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/01_mid_grey.png"),
    type: "layer5"
  },
  {
    id: "02_mid_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/02_mid_grey.png"),
    type: "layer5"
  },
  {
    id: "03_mid_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/03_mid_grey.png"),
    type: "layer5"
  },
  {
    id: "04_mid_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/04_mid_grey.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/01_long_grey.png"),
    type: "layer5"
  },
  {
    id: "02_long_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/02_long_grey.png"),
    type: "layer5"
  },
  {
    id: "03_long_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/03_long_grey.png"),
    type: "layer5"
  },
  {
    id: "04_long_grey",
    src: require("../../imgs/custom/momoro/papa/layer5/04_long_grey.png"),
    type: "layer5"
  },
];
const imgsMamaMomoro = [
  {
    id: "01_face",
    src: require("../../imgs/custom/momoro/mama/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/momoro/mama/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/momoro/mama/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/momoro/mama/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/momoro/mama/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/momoro/mama/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/momoro/mama/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/momoro/mama/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/momoro/mama/layer1/09_face.png"),
    type: "layer1"
  },
  {
    id: "00_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/00_mole.png"),
    type: "layer3"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/01_mole.png"),
    type: "layer3"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/02_mole.png"),
    type: "layer3"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/03_mole.png"),
    type: "layer3"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/04_mole.png"),
    type: "layer3"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/05_mole.png"),
    type: "layer3"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/06_mole.png"),
    type: "layer3"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/07_mole.png"),
    type: "layer3"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/08_mole.png"),
    type: "layer3"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/09_mole.png"),
    type: "layer3"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/momoro/mama/layer3/10_mole.png"),
    type: "layer3"
  },
  {
    id: "00_cheek",
    src: require("../../imgs/custom/momoro/mama/layer2/00_cheek.png"),
    type: "layer2"
  },
  {
    id: "01_cheek",
    src: require("../../imgs/custom/momoro/mama/layer2/01_cheek.png"),
    type: "layer2"
  },
  {
    id: "02_freckles",
    src: require("../../imgs/custom/momoro/mama/layer2/02_freckles.png"),
    type: "layer2"
  },
  {
    id: "03_freckles",
    src: require("../../imgs/custom/momoro/mama/layer2/03_freckles.png"),
    type: "layer2"
  },
  {
    id: "00_glasses",
    src: require("../../imgs/custom/momoro/mama/layer4/00_glasses.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/momoro/mama/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/momoro/mama/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/momoro/mama/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/momoro/mama/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/momoro/mama/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/momoro/mama/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/momoro/mama/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/momoro/mama/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/momoro/mama/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/momoro/mama/layer4/05_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/momoro/mama/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/momoro/mama/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/momoro/mama/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/momoro/mama/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/momoro/mama/layer4/05_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "00_hair",
    src: require("../../imgs/custom/momoro/mama/layer5/00_hair.png"),
    type: "layer5"
  },
  // black
  // very short
  {
    id: "01_very_short_black",
    src: require("../../imgs/custom/momoro/mama/layer5/01_very_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_black",
    src: require("../../imgs/custom/momoro/mama/layer5/02_very_short_black.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/momoro/mama/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/momoro/mama/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/momoro/mama/layer5/03_short_black.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/01_bob_black.png"),
    type: "layer5"
  },
  {
    id: "02_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/02_bob_black.png"),
    type: "layer5"
  },
  {
    id: "03_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/03_bob_black.png"),
    type: "layer5"
  },
  {
    id: "04_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/04_bob_black.png"),
    type: "layer5"
  },
  {
    id: "05_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/05_bob_black.png"),
    type: "layer5"
  },
  {
    id: "06_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/06_bob_black.png"),
    type: "layer5"
  },
  {
    id: "07_bob_black",
    src: require("../../imgs/custom/momoro/mama/layer5/07_bob_black.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/06_long_black.png"),
    type: "layer5"
  },
  {
    id: "07_long_black",
    src: require("../../imgs/custom/momoro/mama/layer5/07_long_black.png"),
    type: "layer5"
  },
  // brown
  // very short
  {
    id: "01_very_short_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/01_very_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/02_very_short_brown.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/03_short_brown.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/01_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "02_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/02_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "03_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/03_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "04_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/04_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "05_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/05_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "06_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/06_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "07_bob_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/07_bob_brown.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/momoro/mama/layer5/07_long_brown.png"),
    type: "layer5"
  },
  // yellow
  // very short
  {
    id: "01_very_short_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/01_very_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/02_very_short_yellow.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/01_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_short_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/02_short_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_short_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/03_short_yellow.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/01_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/02_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/03_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/04_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/05_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "06_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/06_bob_yellow.png"),
    type: "layer5"
  },
  {
    id: "07_bob_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/07_bob_yellow.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/01_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "02_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/02_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "03_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/03_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "04_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/04_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "05_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/05_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "06_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/06_long_yellow.png"),
    type: "layer5"
  },
  {
    id: "07_long_yellow",
    src: require("../../imgs/custom/momoro/mama/layer5/07_long_yellow.png"),
    type: "layer5"
  },
  // grey
  // very short
  {
    id: "01_very_short_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/01_very_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_very_short_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/02_very_short_grey.png"),
    type: "layer5"
  },
  //short
  {
    id: "01_short_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/01_short_grey.png"),
    type: "layer5"
  },
  {
    id: "02_short_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/02_short_grey.png"),
    type: "layer5"
  },
  {
    id: "03_short_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/03_short_grey.png"),
    type: "layer5"
  },
  // Medium
  {
    id: "01_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/01_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "02_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/02_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "03_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/03_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "04_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/04_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "05_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/05_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "06_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/06_bob_grey.png"),
    type: "layer5"
  },
  {
    id: "07_bob_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/07_bob_grey.png"),
    type: "layer5"
  },
  //Long
  {
    id: "01_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/01_long_grey.png"),
    type: "layer5"
  },
  {
    id: "02_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/02_long_grey.png"),
    type: "layer5"
  },
  {
    id: "03_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/03_long_grey.png"),
    type: "layer5"
  },
  {
    id: "04_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/04_long_grey.png"),
    type: "layer5"
  },
  {
    id: "05_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/05_long_grey.png"),
    type: "layer5"
  },
  {
    id: "06_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/06_long_grey.png"),
    type: "layer5"
  },
  {
    id: "07_long_grey",
    src: require("../../imgs/custom/momoro/mama/layer5/07_long_grey.png"),
    type: "layer5"
  },
];

const imgsDaughterAoyama = [
  {
    id: "01_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/aoyama/daughter/layer1/09_face.png"),
    type: "layer1"
  },

  {
    id: "00_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/aoyama/daughter/layer2/10_mole.png"),
    type: "layer2"
  },

  {
    id: "00_cheeks",
    src: require("../../imgs/custom/aoyama/daughter/layer3/00_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/aoyama/daughter/layer3/01_cheeks.png"),
    type: "layer3"
  },

  {
    id: "00_glasses",
    src: require("../../imgs/custom/aoyama/daughter/layer4/00_glasses.png"),
    type: "layer4"
  },
  // color1 black
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/aoyama/daughter/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/aoyama/daughter/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/aoyama/daughter/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/aoyama/daughter/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/aoyama/daughter/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  // color2 brown
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer4/05_glasses_brown.png"),
    type: "layer4"
  },
  // color3 red
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/aoyama/daughter/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/aoyama/daughter/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/aoyama/daughter/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/aoyama/daughter/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/aoyama/daughter/layer4/05_glasses_red.png"),
    type: "layer4"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/aoyama/daughter/layer5/00_hair.png"),
    type: "layer5"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/aoyama/daughter/layer5/00_hair.png"),
    type: "layer5"
  },

  // color1 black
  // black short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_short_black.png"),
    type: "layer5"
  },
  // black bob
  {
    id: "01_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_bob_black.png"),
    type: "layer5"
  },
  {
    id: "02_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_bob_black.png"),
    type: "layer5"
  },
  {
    id: "03_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_bob_black.png"),
    type: "layer5"
  },
  {
    id: "04_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_bob_black.png"),
    type: "layer5"
  },
  {
    id: "05_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_bob_black.png"),
    type: "layer5"
  },
  {
    id: "06_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_bob_black.png"),
    type: "layer5"
  },
  {
    id: "07_bob_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_bob_black.png"),
    type: "layer5"
  },
  // black long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_long_black.png"),
    type: "layer5"
  },
  {
    id: "07_long_black",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_long_black.png"),
    type: "layer5"
  },

  // color2 brown
  // brown short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_short_brown.png"),
    type: "layer5"
  },
  // brown bob
  {
    id: "01_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "02_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "03_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "04_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "05_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "06_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "07_bob_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_bob_brown.png"),
    type: "layer5"
  },
  // brown long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_long_brown.png"),
    type: "layer5"
  },

  // color3 beige
  // beige short
  {
    id: "01_short_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_short_beige.png"),
    type: "layer5"
  },
  {
    id: "02_short_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_short_beige.png"),
    type: "layer5"
  },
  {
    id: "03_short_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_short_beige.png"),
    type: "layer5"
  },
  {
    id: "04_short_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_short_beige.png"),
    type: "layer5"
  },
  {
    id: "05_short_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_short_beige.png"),
    type: "layer5"
  },
  // beige bob
  {
    id: "01_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "02_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "03_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "04_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "05_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "06_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "07_bob_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_bob_beige.png"),
    type: "layer5"
  },
  // beige long
  {
    id: "01_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_long_beige.png"),
    type: "layer5"
  },
  {
    id: "02_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_long_beige.png"),
    type: "layer5"
  },
  {
    id: "03_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_long_beige.png"),
    type: "layer5"
  },
  {
    id: "04_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_long_beige.png"),
    type: "layer5"
  },
  {
    id: "05_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_long_beige.png"),
    type: "layer5"
  },
  {
    id: "06_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_long_beige.png"),
    type: "layer5"
  },
  {
    id: "07_long_beige",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_long_beige.png"),
    type: "layer5"
  },

  // color4 gold
  // gold short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_short_gold.png"),
    type: "layer5"
  },
  // gold bob
  {
    id: "01_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "02_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "03_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "04_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "05_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "06_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "07_bob_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_bob_gold.png"),
    type: "layer5"
  },
  // gold long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_long_gold.png"),
    type: "layer5"
  },
  {
    id: "05_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_long_gold.png"),
    type: "layer5"
  },
  {
    id: "06_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_long_gold.png"),
    type: "layer5"
  },
  {
    id: "07_long_gold",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_long_gold.png"),
    type: "layer5"
  },

  // color5 gray
  // gray short
  {
    id: "01_short_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_short_gray.png"),
    type: "layer5"
  },
  {
    id: "02_short_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_short_gray.png"),
    type: "layer5"
  },
  {
    id: "03_short_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_short_gray.png"),
    type: "layer5"
  },
  {
    id: "04_short_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_short_gray.png"),
    type: "layer5"
  },
  {
    id: "05_short_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_short_gray.png"),
    type: "layer5"
  },
  // gray bob
  {
    id: "01_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "02_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "03_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "04_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "05_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "06_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "07_bob_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_bob_gray.png"),
    type: "layer5"
  },
  // gray long
  {
    id: "01_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/01_long_gray.png"),
    type: "layer5"
  },
  {
    id: "02_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/02_long_gray.png"),
    type: "layer5"
  },
  {
    id: "03_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/03_long_gray.png"),
    type: "layer5"
  },
  {
    id: "04_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/04_long_gray.png"),
    type: "layer5"
  },
  {
    id: "05_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/05_long_gray.png"),
    type: "layer5"
  },
  {
    id: "06_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/06_long_gray.png"),
    type: "layer5"
  },
  {
    id: "07_long_gray",
    src: require("../../imgs/custom/aoyama/daughter/layer5/07_long_gray.png"),
    type: "layer5"
  },

];

const imgsDadAoyama = [
  {
    id: "01_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/aoyama/dad/layer1/09_face.png"),
    type: "layer1"
  },

  {
    id: "00_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/aoyama/dad/layer2/10_mole.png"),
    type: "layer2"
  },

  {
    id: "00_hige",
    src: require("../../imgs/custom/aoyama/dad/layer3/00_hige.png"),
    type: "layer3"
  },

  // color1 black
  {
    id: "01_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/01_hige_black.png"),
    type: "layer3"
  },
  {
    id: "02_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/02_hige_black.png"),
    type: "layer3"
  },
  {
    id: "03_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/03_hige_black.png"),
    type: "layer3"
  },
  {
    id: "04_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/04_hige_black.png"),
    type: "layer3"
  },
  {
    id: "05_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/05_hige_black.png"),
    type: "layer3"
  },
  {
    id: "06_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/06_hige_black.png"),
    type: "layer3"
  },
  {
    id: "07_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/07_hige_black.png"),
    type: "layer3"
  },
  {
    id: "08_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/08_hige_black.png"),
    type: "layer3"
  },
  {
    id: "09_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/09_hige_black.png"),
    type: "layer3"
  },
  {
    id: "10_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/10_hige_black.png"),
    type: "layer3"
  },
  {
    id: "11_hige_black",
    src: require("../../imgs/custom/aoyama/dad/layer3/11_hige_black.png"),
    type: "layer3"
  },

  // color2 white
  {
    id: "01_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/01_hige_white.png"),
    type: "layer3"
  },
  {
    id: "02_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/02_hige_white.png"),
    type: "layer3"
  },
  {
    id: "03_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/03_hige_white.png"),
    type: "layer3"
  },
  {
    id: "04_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/04_hige_white.png"),
    type: "layer3"
  },
  {
    id: "05_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/05_hige_white.png"),
    type: "layer3"
  },
  {
    id: "06_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/06_hige_white.png"),
    type: "layer3"
  },
  {
    id: "07_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/07_hige_white.png"),
    type: "layer3"
  },
  {
    id: "08_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/08_hige_white.png"),
    type: "layer3"
  },
  {
    id: "09_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/09_hige_white.png"),
    type: "layer3"
  },
  {
    id: "10_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/10_hige_white.png"),
    type: "layer3"
  },
  {
    id: "11_hige_white",
    src: require("../../imgs/custom/aoyama/dad/layer3/11_hige_white.png"),
    type: "layer3"
  },

  {
    id: "00_glasses",
    src: require("../../imgs/custom/aoyama/dad/layer4/00_glasses.png"),
    type: "layer4"
  },

  // color1 black
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/aoyama/dad/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/aoyama/dad/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/aoyama/dad/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/aoyama/dad/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/aoyama/dad/layer4/05_glasses_black.png"),
    type: "layer4"
  },

  // color2 brown
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/aoyama/dad/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/aoyama/dad/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/aoyama/dad/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/aoyama/dad/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/aoyama/dad/layer4/05_glasses_brown.png"),
    type: "layer4"
  },

  // color3 red
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/aoyama/dad/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/aoyama/dad/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/aoyama/dad/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/aoyama/dad/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/aoyama/dad/layer4/05_glasses_red.png"),
    type: "layer4"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/aoyama/dad/layer5/00_hair.png"),
    type: "layer5"
  },

  // color1 black
  // black veryshort
  {
    id: "01_veryshort_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_veryshort_black.png"),
    type: "layer5"
  },
  // black short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_short_black.png"),
    type: "layer5"
  },
  {
    id: "06_short_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/06_short_black.png"),
    type: "layer5"
  },
  // black medium
  {
    id: "01_medium_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_medium_black.png"),
    type: "layer5"
  },
  {
    id: "02_medium_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_medium_black.png"),
    type: "layer5"
  },
  {
    id: "03_medium_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_medium_black.png"),
    type: "layer5"
  },
  {
    id: "04_medium_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_medium_black.png"),
    type: "layer5"
  },
  {
    id: "05_medium_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_medium_black.png"),
    type: "layer5"
  },
  // black long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_long_black.png"),
    type: "layer5"
  },

  // color2 brown
  // brown veryshort
  {
    id: "01_veryshort_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_veryshort_brown.png"),
    type: "layer5"
  },
  // brown short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_short_brown.png"),
    type: "layer5"
  },
  {
    id: "06_short_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/06_short_brown.png"),
    type: "layer5"
  },
  // brown medium
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "05_medium_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_medium_brown.png"),
    type: "layer5"
  },
  // brown long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_long_brown.png"),
    type: "layer5"
  },

  // color3 beige
  // beige veryshort
  {
    id: "01_veryshort_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_veryshort_beige.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_veryshort_beige.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_veryshort_beige.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_veryshort_beige.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_veryshort_beige.png"),
    type: "layer5"
  },
  // beige short
  {
    id: "01_short_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_short_beige.png"),
    type: "layer5"
  },
  {
    id: "02_short_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_short_beige.png"),
    type: "layer5"
  },
  {
    id: "03_short_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_short_beige.png"),
    type: "layer5"
  },
  {
    id: "04_short_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_short_beige.png"),
    type: "layer5"
  },
  {
    id: "05_short_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_short_beige.png"),
    type: "layer5"
  },
  {
    id: "06_short_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/06_short_beige.png"),
    type: "layer5"
  },
  // beige medium
  {
    id: "01_medium_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_medium_beige.png"),
    type: "layer5"
  },
  {
    id: "02_medium_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_medium_beige.png"),
    type: "layer5"
  },
  {
    id: "03_medium_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_medium_beige.png"),
    type: "layer5"
  },
  {
    id: "04_medium_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_medium_beige.png"),
    type: "layer5"
  },
  {
    id: "05_medium_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_medium_beige.png"),
    type: "layer5"
  },
  // beige long
  {
    id: "01_long_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_long_beige.png"),
    type: "layer5"
  },
  {
    id: "02_long_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_long_beige.png"),
    type: "layer5"
  },
  {
    id: "03_long_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_long_beige.png"),
    type: "layer5"
  },
  {
    id: "04_long_beige",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_long_beige.png"),
    type: "layer5"
  },

  // color4 gold
  // gold veryshort
  {
    id: "01_veryshort_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_veryshort_gold.png"),
    type: "layer5"
  },
  // gold short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_short_gold.png"),
    type: "layer5"
  },
  {
    id: "06_short_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/06_short_gold.png"),
    type: "layer5"
  },
  // gold medium
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_medium_gold.png"),
    type: "layer5"
  },
  // gold long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_long_gold.png"),
    type: "layer5"
  },

  // color5 gray
  // gray veryshort
  {
    id: "01_veryshort_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_veryshort_gray.png"),
    type: "layer5"
  },
  // gray short
  {
    id: "01_short_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_short_gray.png"),
    type: "layer5"
  },
  {
    id: "02_short_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_short_gray.png"),
    type: "layer5"
  },
  {
    id: "03_short_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_short_gray.png"),
    type: "layer5"
  },
  {
    id: "04_short_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_short_gray.png"),
    type: "layer5"
  },
  {
    id: "05_short_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_short_gray.png"),
    type: "layer5"
  },
  {
    id: "06_short_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/06_short_gray.png"),
    type: "layer5"
  },
  // gray medium
  {
    id: "01_medium_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/05_medium_gray.png"),
    type: "layer5"
  },
  // gray long
  {
    id: "01_long_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/01_long_gray.png"),
    type: "layer5"
  },
  {
    id: "02_long_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/02_long_gray.png"),
    type: "layer5"
  },
  {
    id: "03_long_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/03_long_gray.png"),
    type: "layer5"
  },
  {
    id: "04_long_gray",
    src: require("../../imgs/custom/aoyama/dad/layer5/04_long_gray.png"),
    type: "layer5"
  },

];

const imgsMomAoyama = [
  {
    id: "01_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/02_face.png"),
    type: "layer1"
  },
  {
    id: "03_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/03_face.png"),
    type: "layer1"
  },
  {
    id: "04_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/04_face.png"),
    type: "layer1"
  },
  {
    id: "05_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/05_face.png"),
    type: "layer1"
  },
  {
    id: "06_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/06_face.png"),
    type: "layer1"
  },
  {
    id: "07_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/07_face.png"),
    type: "layer1"
  },
  {
    id: "08_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/08_face.png"),
    type: "layer1"
  },
  {
    id: "09_face",
    src: require("../../imgs/custom/aoyama/mom/layer1/09_face.png"),
    type: "layer1"
  },

  {
    id: "00_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/aoyama/mom/layer2/10_mole.png"),
    type: "layer2"
  },

  {
    id: "00_cheeks",
    src: require("../../imgs/custom/aoyama/mom/layer3/00_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/aoyama/mom/layer3/01_cheeks.png"),
    type: "layer3"
  },

  {
    id: "00_glasses",
    src: require("../../imgs/custom/aoyama/mom/layer4/00_glasses.png"),
    type: "layer4"
  },

  // color1 black
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/aoyama/mom/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/aoyama/mom/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/aoyama/mom/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/aoyama/mom/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/aoyama/mom/layer4/05_glasses_black.png"),
    type: "layer4"
  },

  // color2 brown
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/aoyama/mom/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/aoyama/mom/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/aoyama/mom/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/aoyama/mom/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/aoyama/mom/layer4/05_glasses_brown.png"),
    type: "layer4"
  },

  // color3 red
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/aoyama/mom/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/aoyama/mom/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/aoyama/mom/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/aoyama/mom/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/aoyama/mom/layer4/05_glasses_red.png"),
    type: "layer4"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/aoyama/mom/layer5/00_hair.png"),
    type: "layer5"
  },

  // color1 black
  // black short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_short_black.png"),
    type: "layer5"
  },
  // black bob
  {
    id: "01_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_bob_black.png"),
    type: "layer5"
  },
  {
    id: "02_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_bob_black.png"),
    type: "layer5"
  },
  {
    id: "03_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_bob_black.png"),
    type: "layer5"
  },
  {
    id: "04_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_bob_black.png"),
    type: "layer5"
  },
  {
    id: "05_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_bob_black.png"),
    type: "layer5"
  },
  {
    id: "06_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_bob_black.png"),
    type: "layer5"
  },
  {
    id: "07_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_bob_black.png"),
    type: "layer5"
  },
  {
    id: "08_bob_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_bob_black.png"),
    type: "layer5"
  },
  // black long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_long_black.png"),
    type: "layer5"
  },
  {
    id: "07_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_long_black.png"),
    type: "layer5"
  },
  {
    id: "08_long_black",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_long_black.png"),
    type: "layer5"
  },

  // color2 brown
  // brown short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_short_brown.png"),
    type: "layer5"
  },
  // brown bob
  {
    id: "01_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "02_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "03_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "04_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "05_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "06_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "07_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_bob_brown.png"),
    type: "layer5"
  },
  {
    id: "08_bob_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_bob_brown.png"),
    type: "layer5"
  },
  // brown long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_long_brown.png"),
    type: "layer5"
  },
  {
    id: "08_long_brown",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_long_brown.png"),
    type: "layer5"
  },

  // color3 beige
  // beige short
  {
    id: "01_short_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_short_beige.png"),
    type: "layer5"
  },
  {
    id: "02_short_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_short_beige.png"),
    type: "layer5"
  },
  {
    id: "03_short_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_short_beige.png"),
    type: "layer5"
  },
  {
    id: "04_short_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_short_beige.png"),
    type: "layer5"
  },
  {
    id: "05_short_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_short_beige.png"),
    type: "layer5"
  },
  // beige bob
  {
    id: "01_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "02_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "03_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "04_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "05_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "06_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "07_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_bob_beige.png"),
    type: "layer5"
  },
  {
    id: "08_bob_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_bob_beige.png"),
    type: "layer5"
  },
  // beige long
  {
    id: "01_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_long_beige.png"),
    type: "layer5"
  },
  {
    id: "02_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_long_beige.png"),
    type: "layer5"
  },
  {
    id: "03_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_long_beige.png"),
    type: "layer5"
  },
  {
    id: "04_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_long_beige.png"),
    type: "layer5"
  },
  {
    id: "05_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_long_beige.png"),
    type: "layer5"
  },
  {
    id: "06_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_long_beige.png"),
    type: "layer5"
  },
  {
    id: "07_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_long_beige.png"),
    type: "layer5"
  },
  {
    id: "08_long_beige",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_long_beige.png"),
    type: "layer5"
  },

  // color4 gold
  // gold short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_short_gold.png"),
    type: "layer5"
  },
  // gold bob
  {
    id: "01_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "02_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "03_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "04_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "05_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "06_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "07_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_bob_gold.png"),
    type: "layer5"
  },
  {
    id: "08_bob_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_bob_gold.png"),
    type: "layer5"
  },
  // gold long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_long_gold.png"),
    type: "layer5"
  },
  {
    id: "05_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_long_gold.png"),
    type: "layer5"
  },
  {
    id: "06_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_long_gold.png"),
    type: "layer5"
  },
  {
    id: "07_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_long_gold.png"),
    type: "layer5"
  },
  {
    id: "08_long_gold",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_long_gold.png"),
    type: "layer5"
  },

  // color5 gray
  // gray short
  {
    id: "01_short_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_short_gray.png"),
    type: "layer5"
  },
  {
    id: "02_short_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_short_gray.png"),
    type: "layer5"
  },
  {
    id: "03_short_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_short_gray.png"),
    type: "layer5"
  },
  {
    id: "04_short_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_short_gray.png"),
    type: "layer5"
  },
  {
    id: "05_short_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_short_gray.png"),
    type: "layer5"
  },
  // gray bob
  {
    id: "01_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "02_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "03_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "04_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "05_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "06_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "07_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_bob_gray.png"),
    type: "layer5"
  },
  {
    id: "08_bob_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_bob_gray.png"),
    type: "layer5"
  },
  // gray long
  {
    id: "01_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/01_long_gray.png"),
    type: "layer5"
  },
  {
    id: "02_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/02_long_gray.png"),
    type: "layer5"
  },
  {
    id: "03_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/03_long_gray.png"),
    type: "layer5"
  },
  {
    id: "04_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/04_long_gray.png"),
    type: "layer5"
  },
  {
    id: "05_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/05_long_gray.png"),
    type: "layer5"
  },
  {
    id: "06_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/06_long_gray.png"),
    type: "layer5"
  },
  {
    id: "07_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/07_long_gray.png"),
    type: "layer5"
  },
  {
    id: "08_long_gray",
    src: require("../../imgs/custom/aoyama/mom/layer5/08_long_gray.png"),
    type: "layer5"
  },

];

const imgsSonOkuta = [
  {
    id: "01_face",
    src: require("../../imgs/custom/okuta/son/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/okuta/son/layer1/02_face.png"),
    type: "layer1"
  },

  {
    id: "00_mole",
    src: require("../../imgs/custom/okuta/son/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/okuta/son/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/okuta/son/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/okuta/son/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/okuta/son/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/okuta/son/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/okuta/son/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/okuta/son/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/okuta/son/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/okuta/son/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/okuta/son/layer2/10_mole.png"),
    type: "layer2"
  },

  {
    id: "00_hige",
    src: require("../../imgs/custom/okuta/son/layer3/00_hige.png"),
    type: "layer3"
  },
  // color1 black
  {
    id: "01_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/01_hige_black.png"),
    type: "layer3"
  },
  {
    id: "02_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/02_hige_black.png"),
    type: "layer3"
  },
  {
    id: "03_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/03_hige_black.png"),
    type: "layer3"
  },
  {
    id: "04_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/04_hige_black.png"),
    type: "layer3"
  },
  {
    id: "05_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/05_hige_black.png"),
    type: "layer3"
  },
  {
    id: "06_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/06_hige_black.png"),
    type: "layer3"
  },
  {
    id: "07_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/07_hige_black.png"),
    type: "layer3"
  },
  {
    id: "08_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/08_hige_black.png"),
    type: "layer3"
  },
  {
    id: "09_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/09_hige_black.png"),
    type: "layer3"
  },
  {
    id: "10_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/10_hige_black.png"),
    type: "layer3"
  },
  {
    id: "11_hige_black",
    src: require("../../imgs/custom/okuta/son/layer3/11_hige_black.png"),
    type: "layer3"
  },
  // color2 gray
  {
    id: "01_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/01_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "02_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/02_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "03_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/03_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "04_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/04_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "05_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/05_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "06_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/06_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "07_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/07_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "08_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/08_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "09_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/09_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "10_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/10_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "11_hige_gray",
    src: require("../../imgs/custom/okuta/son/layer3/11_hige_gray.png"),
    type: "layer3"
  },

  {
    id: "00_glasses",
    src: require("../../imgs/custom/okuta/son/layer4/00_glasses.png"),
    type: "layer4"
  },
  // color1 black
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/okuta/son/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/okuta/son/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/okuta/son/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/okuta/son/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/okuta/son/layer4/05_glasses_black.png"),
    type: "layer4"
  },
  // color2 brown
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/okuta/son/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/okuta/son/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/okuta/son/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/okuta/son/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/okuta/son/layer4/05_glasses_brown.png"),
    type: "layer4"
  },
  // color3 red
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/okuta/son/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/okuta/son/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/okuta/son/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/okuta/son/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/okuta/son/layer4/05_glasses_red.png"),
    type: "layer4"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/okuta/son/layer5/00_hair.png"),
    type: "layer5"
  },

  // color1 black
  // black veryshort
  {
    id: "01_veryshort_black",
    src: require("../../imgs/custom/okuta/son/layer5/01_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_black",
    src: require("../../imgs/custom/okuta/son/layer5/02_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_black",
    src: require("../../imgs/custom/okuta/son/layer5/03_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_black",
    src: require("../../imgs/custom/okuta/son/layer5/04_veryshort_black.png"),
    type: "layer5"
  },

  // black short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/okuta/son/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/okuta/son/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/okuta/son/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/okuta/son/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/okuta/son/layer5/05_short_black.png"),
    type: "layer5"
  },

  // black medium
  {
    id: "01_medium_black",
    src: require("../../imgs/custom/okuta/son/layer5/01_medium_black.png"),
    type: "layer5"
  },
  {
    id: "02_medium_black",
    src: require("../../imgs/custom/okuta/son/layer5/02_medium_black.png"),
    type: "layer5"
  },
  {
    id: "03_medium_black",
    src: require("../../imgs/custom/okuta/son/layer5/03_medium_black.png"),
    type: "layer5"
  },
  {
    id: "04_medium_black",
    src: require("../../imgs/custom/okuta/son/layer5/04_medium_black.png"),
    type: "layer5"
  },
  {
    id: "05_medium_black",
    src: require("../../imgs/custom/okuta/son/layer5/05_medium_black.png"),
    type: "layer5"
  },
  {
    id: "06_medium_black",
    src: require("../../imgs/custom/okuta/son/layer5/06_medium_black.png"),
    type: "layer5"
  },

  // black long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/okuta/son/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/okuta/son/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/okuta/son/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/okuta/son/layer5/04_long_black.png"),
    type: "layer5"
  },

  // color2 brown
  // brown veryshort
  {
    id: "01_veryshort_brown",
    src: require("../../imgs/custom/okuta/son/layer5/01_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_brown",
    src: require("../../imgs/custom/okuta/son/layer5/02_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_brown",
    src: require("../../imgs/custom/okuta/son/layer5/03_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_brown",
    src: require("../../imgs/custom/okuta/son/layer5/04_veryshort_brown.png"),
    type: "layer5"
  },

  // brown short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/okuta/son/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/okuta/son/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/okuta/son/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/okuta/son/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/okuta/son/layer5/05_short_brown.png"),
    type: "layer5"
  },

  // brown medium
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/okuta/son/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/okuta/son/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/okuta/son/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/okuta/son/layer5/04_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "05_medium_brown",
    src: require("../../imgs/custom/okuta/son/layer5/05_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "06_medium_brown",
    src: require("../../imgs/custom/okuta/son/layer5/06_medium_brown.png"),
    type: "layer5"
  },

  // brown long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/okuta/son/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/okuta/son/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/okuta/son/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/okuta/son/layer5/04_long_brown.png"),
    type: "layer5"
  },

  // color3 gold
  // gold veryshort
  {
    id: "01_veryshort_gold",
    src: require("../../imgs/custom/okuta/son/layer5/01_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gold",
    src: require("../../imgs/custom/okuta/son/layer5/02_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gold",
    src: require("../../imgs/custom/okuta/son/layer5/03_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gold",
    src: require("../../imgs/custom/okuta/son/layer5/04_veryshort_gold.png"),
    type: "layer5"
  },

  // gold short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/okuta/son/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/okuta/son/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/okuta/son/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/okuta/son/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/okuta/son/layer5/05_short_gold.png"),
    type: "layer5"
  },

  // gold medium
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/okuta/son/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/okuta/son/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/okuta/son/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/okuta/son/layer5/04_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gold",
    src: require("../../imgs/custom/okuta/son/layer5/05_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gold",
    src: require("../../imgs/custom/okuta/son/layer5/06_medium_gold.png"),
    type: "layer5"
  },

  // gold long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/okuta/son/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/okuta/son/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/okuta/son/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/okuta/son/layer5/04_long_gold.png"),
    type: "layer5"
  },


  // color4 gray
  // gray veryshort
  {
    id: "01_veryshort_gray",
    src: require("../../imgs/custom/okuta/son/layer5/01_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gray",
    src: require("../../imgs/custom/okuta/son/layer5/02_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gray",
    src: require("../../imgs/custom/okuta/son/layer5/03_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gray",
    src: require("../../imgs/custom/okuta/son/layer5/04_veryshort_gray.png"),
    type: "layer5"
  },

  // gray short
  {
    id: "01_short_gray",
    src: require("../../imgs/custom/okuta/son/layer5/01_short_gray.png"),
    type: "layer5"
  },
  {
    id: "02_short_gray",
    src: require("../../imgs/custom/okuta/son/layer5/02_short_gray.png"),
    type: "layer5"
  },
  {
    id: "03_short_gray",
    src: require("../../imgs/custom/okuta/son/layer5/03_short_gray.png"),
    type: "layer5"
  },
  {
    id: "04_short_gray",
    src: require("../../imgs/custom/okuta/son/layer5/04_short_gray.png"),
    type: "layer5"
  },
  {
    id: "05_short_gray",
    src: require("../../imgs/custom/okuta/son/layer5/05_short_gray.png"),
    type: "layer5"
  },

  // gray medium
  {
    id: "01_medium_gray",
    src: require("../../imgs/custom/okuta/son/layer5/01_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gray",
    src: require("../../imgs/custom/okuta/son/layer5/02_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gray",
    src: require("../../imgs/custom/okuta/son/layer5/03_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gray",
    src: require("../../imgs/custom/okuta/son/layer5/04_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gray",
    src: require("../../imgs/custom/okuta/son/layer5/05_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gray",
    src: require("../../imgs/custom/okuta/son/layer5/06_medium_gray.png"),
    type: "layer5"
  },

  // gray long
  {
    id: "01_long_gray",
    src: require("../../imgs/custom/okuta/son/layer5/01_long_gray.png"),
    type: "layer5"
  },
  {
    id: "02_long_gray",
    src: require("../../imgs/custom/okuta/son/layer5/02_long_gray.png"),
    type: "layer5"
  },
  {
    id: "03_long_gray",
    src: require("../../imgs/custom/okuta/son/layer5/03_long_gray.png"),
    type: "layer5"
  },
  {
    id: "04_long_gray",
    src: require("../../imgs/custom/okuta/son/layer5/04_long_gray.png"),
    type: "layer5"
  },

];
const imgsDadOkuta = [
  {
    id: "01_face",
    src: require("../../imgs/custom/okuta/dad/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/okuta/dad/layer1/02_face.png"),
    type: "layer1"
  },

  {
    id: "00_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/okuta/dad/layer2/10_mole.png"),
    type: "layer2"
  },

  {
    id: "00_hige",
    src: require("../../imgs/custom/okuta/dad/layer3/00_hige.png"),
    type: "layer3"
  },

  // color1 black
  {
    id: "01_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/01_hige_black.png"),
    type: "layer3"
  },
  {
    id: "02_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/02_hige_black.png"),
    type: "layer3"
  },
  {
    id: "03_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/03_hige_black.png"),
    type: "layer3"
  },
  {
    id: "04_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/04_hige_black.png"),
    type: "layer3"
  },
  {
    id: "05_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/05_hige_black.png"),
    type: "layer3"
  },
  {
    id: "06_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/06_hige_black.png"),
    type: "layer3"
  },
  {
    id: "07_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/07_hige_black.png"),
    type: "layer3"
  },
  {
    id: "08_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/08_hige_black.png"),
    type: "layer3"
  },
  {
    id: "09_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/09_hige_black.png"),
    type: "layer3"
  },
  {
    id: "10_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/10_hige_black.png"),
    type: "layer3"
  },
  {
    id: "11_hige_black",
    src: require("../../imgs/custom/okuta/dad/layer3/11_hige_black.png"),
    type: "layer3"
  },

  // color2 gray
  {
    id: "01_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/01_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "02_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/02_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "03_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/03_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "04_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/04_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "05_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/05_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "06_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/06_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "07_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/07_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "08_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/08_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "09_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/09_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "10_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/10_hige_gray.png"),
    type: "layer3"
  },
  {
    id: "11_hige_gray",
    src: require("../../imgs/custom/okuta/dad/layer3/11_hige_gray.png"),
    type: "layer3"
  },

  {
    id: "00_glasses",
    src: require("../../imgs/custom/okuta/dad/layer4/00_glasses.png"),
    type: "layer4"
  },

  // color1 black
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/okuta/dad/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/okuta/dad/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/okuta/dad/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/okuta/dad/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/okuta/dad/layer4/05_glasses_black.png"),
    type: "layer4"
  },

  // color2 brown
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/okuta/dad/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/okuta/dad/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/okuta/dad/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/okuta/dad/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/okuta/dad/layer4/05_glasses_brown.png"),
    type: "layer4"
  },

  // color3 red
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/okuta/dad/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/okuta/dad/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/okuta/dad/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/okuta/dad/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/okuta/dad/layer4/05_glasses_red.png"),
    type: "layer4"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/okuta/dad/layer5/00_hair.png"),
    type: "layer5"
  },

  // color1 black
  // black veryshort
  {
    id: "01_veryshort_black",
    src: require("../../imgs/custom/okuta/dad/layer5/01_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_black",
    src: require("../../imgs/custom/okuta/dad/layer5/02_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_black",
    src: require("../../imgs/custom/okuta/dad/layer5/03_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_black",
    src: require("../../imgs/custom/okuta/dad/layer5/04_veryshort_black.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_black",
    src: require("../../imgs/custom/okuta/dad/layer5/05_veryshort_black.png"),
    type: "layer5"
  },

  // black short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/okuta/dad/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/okuta/dad/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/okuta/dad/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/okuta/dad/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/okuta/dad/layer5/05_short_black.png"),
    type: "layer5"
  },
  {
    id: "06_short_black",
    src: require("../../imgs/custom/okuta/dad/layer5/06_short_black.png"),
    type: "layer5"
  },

  // black medium
  {
    id: "01_medium_black",
    src: require("../../imgs/custom/okuta/dad/layer5/01_medium_black.png"),
    type: "layer5"
  },
  {
    id: "02_medium_black",
    src: require("../../imgs/custom/okuta/dad/layer5/02_medium_black.png"),
    type: "layer5"
  },
  {
    id: "03_medium_black",
    src: require("../../imgs/custom/okuta/dad/layer5/03_medium_black.png"),
    type: "layer5"
  },
  {
    id: "04_medium_black",
    src: require("../../imgs/custom/okuta/dad/layer5/04_medium_black.png"),
    type: "layer5"
  },
  {
    id: "05_medium_black",
    src: require("../../imgs/custom/okuta/dad/layer5/05_medium_black.png"),
    type: "layer5"
  },
  {
    id: "06_medium_black",
    src: require("../../imgs/custom/okuta/dad/layer5/06_medium_black.png"),
    type: "layer5"
  },

  // black long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/okuta/dad/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/okuta/dad/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/okuta/dad/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/okuta/dad/layer5/04_long_black.png"),
    type: "layer5"
  },

  // color2 brown
  // brown veryshort
  {
    id: "01_veryshort_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/01_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/02_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/03_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/04_veryshort_brown.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/05_veryshort_brown.png"),
    type: "layer5"
  },

  // brown short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/05_short_brown.png"),
    type: "layer5"
  },
  {
    id: "06_short_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/06_short_brown.png"),
    type: "layer5"
  },

  // brown medium
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/04_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "05_medium_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/05_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "06_medium_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/06_medium_brown.png"),
    type: "layer5"
  },

  // brown long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/okuta/dad/layer5/04_long_brown.png"),
    type: "layer5"
  },

  // color3 gold
  // gold veryshort
  {
    id: "01_veryshort_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/01_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/02_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/03_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/04_veryshort_gold.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/05_veryshort_gold.png"),
    type: "layer5"
  },

  // gold short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/05_short_gold.png"),
    type: "layer5"
  },
  {
    id: "06_short_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/06_short_gold.png"),
    type: "layer5"
  },

  // gold medium
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/04_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/05_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/06_medium_gold.png"),
    type: "layer5"
  },

  // gold long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/okuta/dad/layer5/04_long_gold.png"),
    type: "layer5"
  },


  // color4 gray
  // gray veryshort
  {
    id: "01_veryshort_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/01_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "02_veryshort_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/02_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "03_veryshort_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/03_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "04_veryshort_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/04_veryshort_gray.png"),
    type: "layer5"
  },
  {
    id: "05_veryshort_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/05_veryshort_gray.png"),
    type: "layer5"
  },

  // gray short
  {
    id: "01_short_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/01_short_gray.png"),
    type: "layer5"
  },
  {
    id: "02_short_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/02_short_gray.png"),
    type: "layer5"
  },
  {
    id: "03_short_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/03_short_gray.png"),
    type: "layer5"
  },
  {
    id: "04_short_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/04_short_gray.png"),
    type: "layer5"
  },
  {
    id: "05_short_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/05_short_gray.png"),
    type: "layer5"
  },
  {
    id: "06_short_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/06_short_gray.png"),
    type: "layer5"
  },

  // gray medium
  {
    id: "01_medium_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/01_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/02_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/03_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/04_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/05_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/06_medium_gray.png"),
    type: "layer5"
  },

  // gray long
  {
    id: "01_long_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/01_long_gray.png"),
    type: "layer5"
  },
  {
    id: "02_long_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/02_long_gray.png"),
    type: "layer5"
  },
  {
    id: "03_long_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/03_long_gray.png"),
    type: "layer5"
  },
  {
    id: "04_long_gray",
    src: require("../../imgs/custom/okuta/dad/layer5/04_long_gray.png"),
    type: "layer5"
  },
];
const imgsMomOkuta = [
  {
    id: "01_face",
    src: require("../../imgs/custom/okuta/mom/layer1/01_face.png"),
    type: "layer1"
  },
  {
    id: "02_face",
    src: require("../../imgs/custom/okuta/mom/layer1/02_face.png"),
    type: "layer1"
  },

  {
    id: "00_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/00_mole.png"),
    type: "layer2"
  },
  {
    id: "01_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/01_mole.png"),
    type: "layer2"
  },
  {
    id: "02_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/02_mole.png"),
    type: "layer2"
  },
  {
    id: "03_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/03_mole.png"),
    type: "layer2"
  },
  {
    id: "04_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/04_mole.png"),
    type: "layer2"
  },
  {
    id: "05_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/05_mole.png"),
    type: "layer2"
  },
  {
    id: "06_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/06_mole.png"),
    type: "layer2"
  },
  {
    id: "07_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/07_mole.png"),
    type: "layer2"
  },
  {
    id: "08_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/08_mole.png"),
    type: "layer2"
  },
  {
    id: "09_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/09_mole.png"),
    type: "layer2"
  },
  {
    id: "10_mole",
    src: require("../../imgs/custom/okuta/mom/layer2/10_mole.png"),
    type: "layer2"
  },

  {
    id: "00_cheeks",
    src: require("../../imgs/custom/okuta/mom/layer3/00_cheeks.png"),
    type: "layer3"
  },
  {
    id: "01_cheeks",
    src: require("../../imgs/custom/okuta/mom/layer3/01_cheeks.png"),
    type: "layer3"
  },

  {
    id: "00_glasses",
    src: require("../../imgs/custom/okuta/mom/layer4/00_glasses.png"),
    type: "layer4"
  },

  // color1 black
  {
    id: "01_glasses_black",
    src: require("../../imgs/custom/okuta/mom/layer4/01_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_black",
    src: require("../../imgs/custom/okuta/mom/layer4/02_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_black",
    src: require("../../imgs/custom/okuta/mom/layer4/03_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_black",
    src: require("../../imgs/custom/okuta/mom/layer4/04_glasses_black.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_black",
    src: require("../../imgs/custom/okuta/mom/layer4/05_glasses_black.png"),
    type: "layer4"
  },

  // color2 brown
  {
    id: "01_glasses_brown",
    src: require("../../imgs/custom/okuta/mom/layer4/01_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_brown",
    src: require("../../imgs/custom/okuta/mom/layer4/02_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_brown",
    src: require("../../imgs/custom/okuta/mom/layer4/03_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_brown",
    src: require("../../imgs/custom/okuta/mom/layer4/04_glasses_brown.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_brown",
    src: require("../../imgs/custom/okuta/mom/layer4/05_glasses_brown.png"),
    type: "layer4"
  },

  // color3 red
  {
    id: "01_glasses_red",
    src: require("../../imgs/custom/okuta/mom/layer4/01_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "02_glasses_red",
    src: require("../../imgs/custom/okuta/mom/layer4/02_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "03_glasses_red",
    src: require("../../imgs/custom/okuta/mom/layer4/03_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "04_glasses_red",
    src: require("../../imgs/custom/okuta/mom/layer4/04_glasses_red.png"),
    type: "layer4"
  },
  {
    id: "05_glasses_red",
    src: require("../../imgs/custom/okuta/mom/layer4/05_glasses_red.png"),
    type: "layer4"
  },

  {
    id: "00_hair",
    src: require("../../imgs/custom/okuta/mom/layer5/00_hair.png"),
    type: "layer5"
  },

  // color1 black
  // black short
  {
    id: "01_short_black",
    src: require("../../imgs/custom/okuta/mom/layer5/01_short_black.png"),
    type: "layer5"
  },
  {
    id: "02_short_black",
    src: require("../../imgs/custom/okuta/mom/layer5/02_short_black.png"),
    type: "layer5"
  },
  {
    id: "03_short_black",
    src: require("../../imgs/custom/okuta/mom/layer5/03_short_black.png"),
    type: "layer5"
  },
  {
    id: "04_short_black",
    src: require("../../imgs/custom/okuta/mom/layer5/04_short_black.png"),
    type: "layer5"
  },
  {
    id: "05_short_black",
    src: require("../../imgs/custom/okuta/mom/layer5/05_short_black.png"),
    type: "layer5"
  },
  {
    id: "06_short_black",
    src: require("../../imgs/custom/okuta/mom/layer5/06_short_black.png"),
    type: "layer5"
  },

  // black medium
  {
    id: "01_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/01_medium_black.png"),
    type: "layer5"
  },
  {
    id: "02_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/02_medium_black.png"),
    type: "layer5"
  },
  {
    id: "03_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/03_medium_black.png"),
    type: "layer5"
  },
  {
    id: "04_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/04_medium_black.png"),
    type: "layer5"
  },
  {
    id: "05_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/05_medium_black.png"),
    type: "layer5"
  },
  {
    id: "06_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/06_medium_black.png"),
    type: "layer5"
  },
  {
    id: "07_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/07_medium_black.png"),
    type: "layer5"
  },
  {
    id: "08_medium_black",
    src: require("../../imgs/custom/okuta/mom/layer5/08_medium_black.png"),
    type: "layer5"
  },

  // black long
  {
    id: "01_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/01_long_black.png"),
    type: "layer5"
  },
  {
    id: "02_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/02_long_black.png"),
    type: "layer5"
  },
  {
    id: "03_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/03_long_black.png"),
    type: "layer5"
  },
  {
    id: "04_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/04_long_black.png"),
    type: "layer5"
  },
  {
    id: "05_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/05_long_black.png"),
    type: "layer5"
  },
  {
    id: "06_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/06_long_black.png"),
    type: "layer5"
  },
  {
    id: "07_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/07_long_black.png"),
    type: "layer5"
  },
  {
    id: "08_long_black",
    src: require("../../imgs/custom/okuta/mom/layer5/08_long_black.png"),
    type: "layer5"
  },

  // color2 brown
  // brown short
  {
    id: "01_short_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/01_short_brown.png"),
    type: "layer5"
  },
  {
    id: "02_short_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/02_short_brown.png"),
    type: "layer5"
  },
  {
    id: "03_short_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/03_short_brown.png"),
    type: "layer5"
  },
  {
    id: "04_short_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/04_short_brown.png"),
    type: "layer5"
  },
  {
    id: "05_short_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/05_short_brown.png"),
    type: "layer5"
  },
  {
    id: "06_short_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/06_short_brown.png"),
    type: "layer5"
  },

  // brown medium
  {
    id: "01_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/01_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "02_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/02_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "03_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/03_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "04_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/04_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "05_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/05_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "06_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/06_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "07_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/07_medium_brown.png"),
    type: "layer5"
  },
  {
    id: "08_medium_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/08_medium_brown.png"),
    type: "layer5"
  },

  // brown long
  {
    id: "01_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/01_long_brown.png"),
    type: "layer5"
  },
  {
    id: "02_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/02_long_brown.png"),
    type: "layer5"
  },
  {
    id: "03_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/03_long_brown.png"),
    type: "layer5"
  },
  {
    id: "04_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/04_long_brown.png"),
    type: "layer5"
  },
  {
    id: "05_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/05_long_brown.png"),
    type: "layer5"
  },
  {
    id: "06_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/06_long_brown.png"),
    type: "layer5"
  },
  {
    id: "07_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/07_long_brown.png"),
    type: "layer5"
  },
  {
    id: "08_long_brown",
    src: require("../../imgs/custom/okuta/mom/layer5/08_long_brown.png"),
    type: "layer5"
  },

  // color3 gold
  // gold short
  {
    id: "01_short_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/01_short_gold.png"),
    type: "layer5"
  },
  {
    id: "02_short_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/02_short_gold.png"),
    type: "layer5"
  },
  {
    id: "03_short_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/03_short_gold.png"),
    type: "layer5"
  },
  {
    id: "04_short_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/04_short_gold.png"),
    type: "layer5"
  },
  {
    id: "05_short_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/05_short_gold.png"),
    type: "layer5"
  },
  {
    id: "06_short_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/06_short_gold.png"),
    type: "layer5"
  },

  // gold medium
  {
    id: "01_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/01_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/02_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/03_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/04_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/05_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/06_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "07_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/07_medium_gold.png"),
    type: "layer5"
  },
  {
    id: "08_medium_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/08_medium_gold.png"),
    type: "layer5"
  },

  // gold long
  {
    id: "01_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/01_long_gold.png"),
    type: "layer5"
  },
  {
    id: "02_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/02_long_gold.png"),
    type: "layer5"
  },
  {
    id: "03_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/03_long_gold.png"),
    type: "layer5"
  },
  {
    id: "04_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/04_long_gold.png"),
    type: "layer5"
  },
  {
    id: "05_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/05_long_gold.png"),
    type: "layer5"
  },
  {
    id: "06_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/06_long_gold.png"),
    type: "layer5"
  },
  {
    id: "07_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/07_long_gold.png"),
    type: "layer5"
  },
  {
    id: "08_long_gold",
    src: require("../../imgs/custom/okuta/mom/layer5/08_long_gold.png"),
    type: "layer5"
  },

  // color4 gray
  // gray short
  {
    id: "01_short_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/01_short_gray.png"),
    type: "layer5"
  },
  {
    id: "02_short_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/02_short_gray.png"),
    type: "layer5"
  },
  {
    id: "03_short_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/03_short_gray.png"),
    type: "layer5"
  },
  {
    id: "04_short_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/04_short_gray.png"),
    type: "layer5"
  },
  {
    id: "05_short_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/05_short_gray.png"),
    type: "layer5"
  },
  {
    id: "06_short_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/06_short_gray.png"),
    type: "layer5"
  },

  // gold medium
  {
    id: "01_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/01_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "02_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/02_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "03_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/03_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "04_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/04_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "05_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/05_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "06_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/06_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "07_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/07_medium_gray.png"),
    type: "layer5"
  },
  {
    id: "08_medium_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/08_medium_gray.png"),
    type: "layer5"
  },

  // gray long
  {
    id: "01_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/01_long_gray.png"),
    type: "layer5"
  },
  {
    id: "02_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/02_long_gray.png"),
    type: "layer5"
  },
  {
    id: "03_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/03_long_gray.png"),
    type: "layer5"
  },
  {
    id: "04_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/04_long_gray.png"),
    type: "layer5"
  },
  {
    id: "05_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/05_long_gray.png"),
    type: "layer5"
  },
  {
    id: "06_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/06_long_gray.png"),
    type: "layer5"
  },
  {
    id: "07_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/07_long_gray.png"),
    type: "layer5"
  },
  {
    id: "08_long_gray",
    src: require("../../imgs/custom/okuta/mom/layer5/08_long_gray.png"),
    type: "layer5"
  },

];

export {
  imgsFemaleKanai,
  imgsMaleKanai,
  imgsFemaleNakagawa,
  imgsMaleNakagawa,
  imgsBoyNakagawa,
  imgsGirlNakagawa,
  imgsPapaNakagawa,
  imgsMamaNakagawa,
  imgsBoyMomoro,
  imgsGirlMomoro,
  imgsPapaMomoro,
  imgsMamaMomoro,
  imgsDaughterAoyama,
  imgsDadAoyama,
  imgsMomAoyama,
  imgsSonOkuta,
  imgsDadOkuta,
  imgsMomOkuta
};


// WEBPACK FOOTER //
// ./src/components/steps/FaceSelectionImage.js